import Modal, { defaultModalManager } from './Modal';
export { defaultModalManager };
export { default as ModalManager } from './ModalManager';
export default Modal;